export default "__VITE_ASSET__BYRGyI45__"